import OtsCustomDialog from './OtsCustomDialog'

OtsCustomDialog.install = Vue => {
    Vue.component(OtsCustomDialog.name,OtsCustomDialog)
}

export default OtsCustomDialog